module.exports = __webpack_public_path__ + "static/media/momolevel.3189e643.jpg";